<app-modal
  #deleteAttachmentModal
  [modalMessage]="app.text.attachments.deleteQuestion"
  [modalTitle]="app.text.attachments.modalTitle"
  (ok)="app.file.delete(fileLink)"
></app-modal>
<app-modal
  #unmarkAttachmentModal
  [modalMessage]="app.text.attachments.unmarkQuestion"
  [modalTitle]="app.text.attachments.modalTitle"
  (ok)="app.attachments.markAttachment(fileName, fileDetails, fileLink, false)"
></app-modal>

<div class="col-md-12 ps-0">
  <!-- <div *ngIf="!app.attachments.sortingMode"> -->
  @for (tag of getTags(); track tag) {
    <span>
      <span class="badge selected attBadge" style="margin-right: 5px"
        >{{ tag }}
        @if (hasPermissionToDeleteTag(fileDetails)) {
          <i
            class="fa fa-times fa-small ms-1"
            (click)="app.attachment.deleteTag(fileDetails, tag, fileLink)"
            ></i
            >
          }</span>
        </span>
      }
    <!-- </div> -->
  </div>
  <!-- attachment name & attachment details -->
  <div class="col-md-12 p-1">
    @if (
      fileDetails &&
      fileDetails.fziAttachment === true &&
      editPermission &&
      app.permission.attachment.markAttAsSensitive
      ) {
      <button
        class="btn attBtn"
        [ngbTooltip]="app.text.attachments.markAsSensitive"
        (click)="unmarkAttachmentModal.open()"
        >
        <i class="fas fa-user-lock"></i>
      </button>
    }
    @if (
      fileDetails &&
      fileDetails.fziAttachment !== true &&
      checkPermission(fileName) &&
      app.permission.attachment.markAttAsSensitive
      ) {
      <button
    (click)="
      app.attachments.markAttachment(fileName, fileDetails, fileLink, true)
    "
        class="btn attBtn"
        [ngbTooltip]="app.text.attachments.unmarkAsSensitive"
        >
        <i class="fad fa-user-unlock" id="fa-red"></i>
      </button>
    }
    @if (!url) {
      <span>
        <a
          class="attachment pointer"
          [ngClass]="{ 'attachment-oc-sm': app.view === 'oc-home' }"
          (click)="downloadAttachment(fileLink)"
          >
          <span class="attachmentName">
            {{ displayFileName }}
          </span>
          <span class="attachmentExtension">
            {{ fileExtension }}
          </span>
        </a>
      </span>
    }
    @if (url) {
      <span>
        <a
          class="attachment pointer"
          [ngClass]="{ 'attachment-oc-sm': app.view === 'oc-home' }"
          data-bs-toggle="dropdown"
          >
          <span class="attachmentName">
            {{ displayFileName }}
          </span>
          <span class="attachmentExtension">
            {{ fileExtension }}
          </span>
        </a>
        <div class="dropdown-menu m-0 p-1">
          <a
            class="dropdown-item attDropdown m-0 p-1"
            (click)="downloadAttachment(fileLink)"
            >
            <i class="fa fa-download"></i>&nbsp; {{ app.text.attachments.download }}
          </a>
          <a class="dropdown-item attDropdown m-0 p-1" [href]="url" target="_blank">
            <i class="fa fa-external-link"></i>&nbsp;
            {{ app.text.attachments.openLink }}
          </a>
        </div>
      </span>
    }
    @if (checkPermission(fileName)) {
      <button
        class="btn attBtn"
        (click)="showTagField = !showTagField"
        [title]="app.text.attachments.addTag"
        >
        <i class="fa fa-tag"></i>
      </button>
    }
    @if (checkPermission(fileName)) {
      <button
        class="btn attBtn"
        (click)="deleteAttachmentModal.open()"
        [title]="app.text.attachments.delete"
        >
        <i class="fa fa-trash"></i>
      </button>
    }

    <div class="float-end">
      @if (fileDetails != null && app.view != 'oc-home') {
        <small
          class="attachmentDetails"
          >
          {{ fileDetails.uploadTime | date : "yyyy-MM-dd HH:mm" }}</small
          >
        }
        @if (fileDetails != null && app.view == 'oc-home') {
          <small
            class="attachmentDetails"
            >
            {{ app.OCHome.getTimeInfo(fileDetails.uploadTime) }}</small
            >
          }
        </div>
      </div>
      <!-- input for the add new tag -->
      <div class="col-md-12">
        @if (showTagField) {
          <div class="attachment-new-tag">
            <div class="col-sm-9">
              <app-field
                [model]="tagModel"
                [field]="app.fieldId.attachment.tag"
              ></app-field>
            </div>
            <div>
              <button class="btn" (click)="addTag()" [disabled]="isDisabled()">
                <i class="fa fa-check"> </i>
              </button>
              <button class="btn" (click)="showTagField = false">
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        }
      </div>
